export enum ECampaignDetailsTab {
	OVERVIEW = 'overview',
	CODES = 'codes',
	STATS = 'stats',
	HISTORY = 'history',
}

export interface ICampaignStatsModel {
	totalCodes: number
	totalUses: number
	grossRevenue: number
	netRevenue: number
	discountCost: number
	avgAovWithCode: number
	avgAovWithoutCode: number
	conversionRate: number
}

export const computeCampaignStats = (codes: ICodeListItemModel[]): ICampaignStatsModel => {
	const totalUses = codes.reduce((sum, c) => sum + c.usageCount, 0)
	const PER_USE_GROSS = 20000
	const NET_FACTOR = 0.813
	const DISCOUNT_FACTOR = 0.15
	const AOV_WITH = 20000
	const AOV_WITHOUT = 22000
	const CONVERSION = 28
	return {
		totalCodes: codes.length,
		grossRevenue: totalUses * PER_USE_GROSS,
		netRevenue: Math.round(totalUses * PER_USE_GROSS * NET_FACTOR),
		discountCost: Math.round(totalUses * PER_USE_GROSS * DISCOUNT_FACTOR),
		avgAovWithCode: AOV_WITH,
		avgAovWithoutCode: AOV_WITHOUT,
		conversionRate: CONVERSION,
		totalUses,
	}
}

export const CAMPAIGN_DRAWER_CODES_PER_PAGE = 5
export const CAMPAIGN_DRAWER_HISTORY_PER_PAGE = 5
